<div class="auth-layout-bg w-full flex items-center justify-center">
  <app-language-switcher class="fixed top-4 end-4 z-20"></app-language-switcher>

  <ng-container *ngIf="hideContainer; else container">
    <router-outlet></router-outlet>
  </ng-container>
  <ng-template #container>
    <div
      class="rounded-2xl my-8 bg-base w-full px-4 sm:px-8 py-8"
      [ngClass]="
        wideContainer ? 'sm:max-w-lg max-w-[18.125rem]' : 'sm:max-w-md max-w-sm'
      "
    >
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</div>
